import { render, staticRenderFns } from "./completeinfor.vue?vue&type=template&id=4a88f954&"
import script from "./completeinfor.vue?vue&type=script&lang=js&"
export * from "./completeinfor.vue?vue&type=script&lang=js&"
import style0 from "./completeinfor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports